import { z } from "zod";

const TaskReferenceSchema = z.object({
  id: z.string(),
  completed: z.boolean(),
});

export const MilestoneSchema = z.object({
  id: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  title: z.string(),
  dueDate: z.coerce.date().nullable().optional(),
  order: z.string(),
  status: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  taskList: z.array(TaskReferenceSchema).optional(),
});

export type Milestone = z.infer<typeof MilestoneSchema>;

export type NewMilestone = Omit<Milestone, "id" | "createdAt" | "updatedAt" | "taskList">;
